import { useTranslation } from "react-i18next";
import Modal from "src/components/Modal";
import { Link, useNavigate } from "src/navigation";
import { useRenewalOverview } from "../interfaces/Renwals";
import { IpRight } from "../interfaces/renewal_types";
import { paymentHandlingAction, renewalHandlingActionName } from "../import";
import { isImported } from "../state/modern_states";
import { useDummyIpRights } from "./IpRights";
import { useIpRights } from "../interfaces/IpRights";

export function DummyImportRenewalMember() {
  const { t } = useTranslation()

  const navigate = useNavigate()

  const { member, ipRightImportStatus, ipRight } = useRenewalOverview()
  const { stopIpRight } = useIpRights()
  const { postIpRight, deriveInitial } = useDummyIpRights()

  const imported = isImported(ipRightImportStatus)
  const action = paymentHandlingAction({ status: ipRightImportStatus, imported })

  async function doImport() {
    const initial = ipRight ? {...ipRight, status: 'Ready'} : deriveInitial(member)
    console.log({ initial })
    await postIpRight(initial as IpRight, member.familyMemberId)
    navigate("../..")
  }

  async function doStop() {
    await stopIpRight(ipRight)
    navigate("../..")
  }

  const canStop = imported && ipRightImportStatus.substatus !== 'stopped' 

  return (
    <Modal>
      <div className="p-4">
        <h2>
          {member.internalReference}: {t('payment-handling')}
        </h2>
      </div>
      <div className="p-4 flex flex-row-reverse gap-4 bg-pcx-200">
        <button
          className="btn-primary"
          onClick={doImport}
          >
            {t(renewalHandlingActionName(action))}
          </button>
        <Link to="../.." className="btn-secondary">
          {t('cancel')}
        </Link>
        {canStop && <button className="btn-warn mr-10" onClick={doStop}>Stop</button>}
      </div>
    </Modal>
  )
}